import { useMemo } from "react";

import { qrUrlTrack, stringIsFilled } from "../shared";
import { SnkrsCalProps } from "../screens/SnkrsCal";
import SnkrsTypography from "./SnkrsTypography";

export function SnkrsDropQr({
    url,
    cta = "VIEW IN SNKRS",
    concept = "wof",
    large = false,
}: {
    url: string;
    cta?: string;
    concept?: SnkrsCalProps["concept"];
    large?: boolean;
}) {
    const fullUrl = useMemo(() => qrUrlTrack(url), [url]);
    const DEFAULT_QR_SIZE = 130;
    const qrSize = large ? DEFAULT_QR_SIZE * 1.5 : 130;

    return (
        <div style={{ position: "absolute", bottom: 45, minWidth: 400 }}>
            {stringIsFilled(cta) ? (
                <SnkrsTypography variant={"jordan"} color={"black"} size={20}>
                    {cta}
                </SnkrsTypography>
            ) : null}

            <div style={{ display: "flex", gap: 20, marginTop: 13, alignItems: "center" }}>
                <img
                    style={{
                        width: qrSize,
                        height: qrSize,
                        border: concept === "wof" ? "1px solid rgba(0,0,0,0.25)" : "1px solid black",
                        borderRadius: concept === "wof" ? 5.7 : 0,
                    }}
                    src={fullUrl}
                    alt=""
                />
            </div>
        </div>
    );
}
